$(function () {

  /*
  let sliderThumbnail = new Swiper('.thumb-swiper-container', {
    //slidesPerView: 'auto',
    slidesPerView: 9,
    slidesPerGroup: 9,
    freeMode: true,
    //watchSlidesVisibility: true,
    //watchSlidesProgress: true,
    direction: 'vertical',
    shortSwipes: false,
    longSwipes: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  //スライドショー
  let slider = new Swiper('.product-swiper-container', {
    direction: 'horizontal',
    loop: true,
    speed: 300,
    thumbs: {
      swiper: sliderThumbnail
    }
  });
  */

  // のし(Bold)
  /*
  $(document).on('change', 'select[name="properties[のしの有無]"]' , function() {
	var noshi_val = $('select[name="properties[のしの有無]"]').val();
	if(noshi_val == '必要') {
      //$('.noshi-property-btn').css('display', 'block');
      $('.noshi-bg,.noshi-property').fadeIn('slow');
      $('.noshi-property').find('input[type=radio]').prop('disabled', false);
      $('.product-form__cart-submit').addClass('disabled');
    } else {
      //$('.noshi-property-btn').hide();
      $('.noshi-property').find('select').val('');
      //$('.noshi-property').find('input[type=radio]').prop('disabled', true);
      $('.noshi-property').find('input[type=radio]').removeAttr('checked').prop({disabled:true,checked:false});
      $('.noshi-property').find('input[type=text]').val('');
      $('.noshi-other,.noshi-personal,.noshi-corp,.noshi-furigana-wrap,.noshi-info-wrap').hide();
      $('#noshi-info').empty();
      $('#noshi-design').removeClass('open');
      $('#noshi-design').css('background-image', 'none');
      $('#noshi-design').css('border', 'none');
      $('.product-form__cart-submit').removeClass('disabled');
    }
  });
*/

  // のし(InfiniteOptions)
  $(document).on('change', 'select[name="properties[のし]"]', function () {
    var noshi_val = $('select[name="properties[のし]"]').val();
    if (noshi_val.indexOf('必要') >= 0) {
      $('.noshi-property-btn').css('display', 'block');
      $('.noshi-bg,.noshi-property').fadeIn('slow');
      $('.noshi-property').find('input[type=radio]').prop('disabled', false);
      $('.product-form__cart-submit').addClass('disabled');
    } else {
      $('.noshi-property-btn').hide();
      $('.noshi-property').find('select').val('');
      //$('.noshi-property').find('input[type=radio]').prop('disabled', true);
      $('.noshi-property').find('input[type=radio]').removeAttr('checked').prop({disabled: true, checked: false});
      $('.noshi-property').find('input[type=text]').val('');
      $('input[name="properties[名1]"]').removeClass('noshi-required');
      $('input[name="properties[会社]"]').removeClass('noshi-required');
      $('.noshi-other,.noshi-personal,.noshi-corp,.noshi-furigana-wrap,.noshi-info-wrap').hide();
      $('#noshi-info').empty();
      $('#noshi-design').removeClass('open');
      $('#noshi-design').css('background-image', 'none');
      $('#noshi-design').css('border', 'none');
      $('.product-form__cart-submit').removeClass('disabled');
    }
  });

  //　のし
  var radioDefault = $('.noshi-radio').html();

  /*
  $('.noshi-select').change(function() {
	var noshi_select_val = $('.noshi-select').val();
	if(noshi_select_val == '必要') {
      $('.noshi-property-btn').css('display', 'block');
      $('.noshi-property').find('input[type=radio]').prop('disabled', false);
    } else if(noshi_select_val == '不要') {
      $('.noshi-property-btn').hide();
      $('.noshi-property').find('select').val('');
      //$('.noshi-property').find('input[type=radio]').prop('disabled', true);
      $('.noshi-property').find('input[type=radio]').removeAttr('checked').prop({disabled:true,checked:false});
      $('.noshi-property').find('input[type=text]').val('');
      $('.noshi-other,.noshi-personal,.noshi-corp,.noshi-furigana-wrap').hide();
      $('#noshi-info').empty();
      $('#noshi-design').css('background-image', 'none');
    }
  });
  */

  var noshi_type_flg = false;
  var noshi_kakekata_flg = false;
  var noshi_naire_flg = false;

  $('.noshi-bg,.noshi-close').click(function () {
    var require_text = $('.noshi-required').val();
    if (require_text == '') {
      alert('必須項目が入力されていません');
      e.stopPropagation();
    }

    $('.noshi-bg,.noshi-property').fadeOut('slow');
  });

  $('.noshi-tojiru').click(function () {
    $('.noshi-property').find('select').val('');
    $('.noshi-property').find('input[type=radio]').removeAttr('checked').prop({disabled: true, checked: false});
    $('.noshi-property').find('input[type=text]').val('');
    $('input[name="properties[名1]"]').removeClass('noshi-required');
    $('input[name="properties[会社]"]').removeClass('noshi-required');
    $('.noshi-other,.noshi-personal,.noshi-corp,.noshi-furigana-wrap,.noshi-info-wrap').hide();
    $('#noshi-info').empty();
    $('.product-form__cart-submit').addClass('disabled');
    noshi_type_flg = false;
    noshi_kakekata_flg = false;
    noshi_naire_flg = false;
    $('#noshi-design').removeClass('open');
    $('#noshi-design').css('background-image', 'none');
    $('#noshi-design').css('border', 'none');
    $('.noshi-bg,.noshi-property').fadeOut('slow');
  });


  $('.noshi-property-btn').on('click', function () {
    $('.noshi-property').find('input[type=radio]').prop('disabled', false);
    $('.noshi-bg,.noshi-property').fadeIn('slow');

    $('.noshi-bg,.noshi-close').click(function () {
      var require_text = $('.noshi-required').val();
      if (require_text == '') {
        alert('必須項目が入力されていません');
        e.stopPropagation();
      }

      $('.noshi-bg,.noshi-property').fadeOut('slow');
    });

    $('.noshi-tojiru').click(function () {
      $('.noshi-property').find('select').val('');
      $('.noshi-property').find('input[type=radio]').removeAttr('checked').prop({disabled: true, checked: false});
      $('.noshi-property').find('input[type=text]').val('');
      $('.noshi-other,.noshi-personal,.noshi-corp,.noshi-furigana-wrap,.noshi-info-wrap').hide();
      $('#noshi-info').empty();
      $('.product-form__cart-submit').addClass('disabled');
      noshi_type_flg = false;
      noshi_kakekata_flg = false;
      noshi_naire_flg = false;
      $('#noshi-design').removeClass('open');
      $('#noshi-design').css('background-image', 'none');
      $('#noshi-design').css('border', 'none');
      $('.noshi-bg,.noshi-property').fadeOut('slow');
    });

  });


  var n_url = 'https://cdn.shopify.com/s/files/1/0588/2472/0538/t/2/assets/noshi_data.json';
  $.getJSON(n_url, function (n_data) { //のしテキストデータを使う

    $('#noshitype').on('change', function () {
      var type_val = $(this).val(); //選択された項目のvalueを取得
      var omote_str = ''; // 表書き
      var omote_img = ''; // のし画像
      var type_id = String($('#noshitype option:selected').data('id'));

      if (type_val) { //valueに何か値が入っていた場合

        noshi_type_flg = true;
        if (noshi_kakekata_flg && noshi_naire_flg) {
          $('.product-form__cart-submit').removeClass('disabled');
        }

        for (var i in n_data) {
          if (n_data[i].id === type_id) {
            omote_str = n_data[i].text;
            omote_img = 'url(//cdn.shopify.com/s/files/1/0588/2472/0538/files/noshi' + n_data[i].id + '.jpg)';
          }
        }

        // のし画像表示
        if (type_val.indexOf('紅白蝶結び') > -1) {

          $('#noshi-design').addClass('open');
          $('#noshi-design').css('background-image', omote_img);
          $('#noshi-design').css('border', '1px solid #D7D6D8');
          $('.noshi-info-wrap').fadeIn();
          $('#noshi-info').html('【水引】 ' + omote_str);

          if (type_id === '18' || type_id === '19') {
            $('.noshi-personal-child').hide();
            $('.noshi-required-wrap, .noshi-furigana-wrap').fadeIn();
          } else {
            $('.noshi-personal-child').fadeIn();
            $('.noshi-furigana-wrap').hide();
          }

        } else if (type_val.indexOf('紅白結び切り') > -1) {
          $('#noshi-design').addClass('open');
          $('#noshi-design').css('background-image', omote_img);
          $('#noshi-design').css('border', '1px solid #D7D6D8');
          $('.noshi-info-wrap').fadeIn();
          $('#noshi-info').html('【水引】 ' + omote_str);
          $('.noshi-personal-child').fadeIn();
          $('.noshi-furigana-wrap').hide();

        } else {
          $('#noshi-design').addClass('open');
          $('#noshi-design').css('background-image', omote_img);
          $('#noshi-design').css('border', '1px solid #D7D6D8');
          $('.noshi-info-wrap').fadeIn();
          $('#noshi-info').html('【水引】 ' + omote_str);
          $('.noshi-personal-child').fadeIn();
          $('.noshi-furigana-wrap').hide();
        }
      } else { //valueに何も値が入っていない場合
        noshi_type_flg = false;
        $('.product-form__cart-submit').addClass('disabled');
        $('#noshi-design').removeClass('open');
        $('#noshi-design').css('background-image', 'none');
        $('#noshi-design').css('border', 'none');
        $('.noshi-furigana-wrap,.noshi-info-wrap').hide();
        $('#noshi-info').empty();

        if ($('input[name="properties[名入]"]:checked').val() == '個人') {
          $('.noshi-personal-child').fadeIn();
          $('.noshi-furigana-wrap').hide();
        }
      }
    });

  }); // json end

  // のしの掛け方
  $('input[name="properties[かけ方]"]').on('change', function () {
    var noshi_kakekata_val = $('input[name="properties[かけ方]"]:checked').val();
    if (noshi_kakekata_val) {
      noshi_kakekata_flg = true;
      if (noshi_type_flg && noshi_naire_flg) {
        $('.product-form__cart-submit').removeClass('disabled');
      }
    } else {
      noshi_kakekata_flg = false;
      $('.product-form__cart-submit').addClass('disabled');
    }
  });


  $('input[name="properties[名入]"]').change(function () {
    var naire_val = $(this).val();
    if (naire_val) {
      noshi_naire_flg = true;
      if (noshi_type_flg && noshi_kakekata_flg) {
        $('.product-form__cart-submit').removeClass('disabled');
      }

      if (naire_val == '個人') {
        $('.err_text p').remove();
        $('.noshi-personal').fadeIn('slow');
        //$('input[name="properties[名1]"]').prop('required', true);
        $('input[name="properties[名1]"]').addClass('noshi-required');
        $('.noshi-corp').hide();
        $('.noshi-corp').find('input').val('');
        //$('input[name="properties[会社]"]').prop('required', false);
        $('input[name="properties[会社]"]').removeClass('noshi-required');

        if ($('#noshitype').val() == '') {
          $('.noshi-personal-child').fadeIn();
          $('.noshi-furigana-wrap').hide();
        }

      } else if (naire_val == '法人') {
        $('.err_text p').remove();
        $('.noshi-corp').fadeIn('slow');
        //$('input[name="properties[会社]"]').prop('required', true);
        $('input[name="properties[会社]"]').addClass('noshi-required');
        $('.noshi-personal').hide();
        $('.noshi-personal').find('input').val('');
        //$('input[name="properties[名1]"]').prop('required', false);
        $('input[name="properties[名1]"]').removeClass('noshi-required');
      } else {
        $('.err_text p').remove();
        $('.noshi-corp').hide();
        $('.noshi-corp').find('input').val('');
        //$('input[name="properties[会社]"]').prop('required', false);
        $('input[name="properties[会社]"]').removeClass('noshi-required');
        $('.noshi-personal').hide();
        $('.noshi-personal').find('input').val('');
        //$('input[name="properties[名1]"]').prop('required', false);
        $('input[name="properties[名1]"]').removeClass('noshi-required');
      }

    } else {
      noshi_naire_flg = false;
      $('.product-form__cart-submit').addClass('disabled');
    }
  });

  $('input[name="properties[ラッピング]"]').change(function () {
    var wrap_val = $(this).val();
    if (wrap_val == 'あり') {
      $('.wrapping-type').fadeIn('slow');
    } else {
      $('.wrapping-type').hide();
      $('.wrapping-type').find('input').val('');
    }
  });

  /*
  // エラーテキスト
  $(document).on('blur', '.noshi-required' , function() {
    var required_val = $(this).val();
    check_textbox(required_val);
  });

  function check_textbox(str){
	$('.err_text p').remove();
	var _result = true;
	var _textbox = $.trim(str);

	if(_textbox.match(/^[ 　\r\n\t]*$/)){
      $('.err_text').append("<p>必須項目です</p>");
      _result = false;
    } else if(_textbox.length > 10) {
      $('.err_text').append("<p>10文字以内で入力してください</p>");
      _result = false;
    }
    return _result;
  }
  */

  // 着日指定
  $('#chakubi').on('change', function () {
    if ($(this).is(':checked')) {
      $('.product-form__cart-submit').prop('disabled', false);
    } else {
      $('.product-form__cart-submit').prop('disabled', true);
    }
  });

  // 着日指定
  $('#frozenchk').on('change', function () {
    if ($(this).is(':checked')) {
      $('.product-form__cart-submit').prop('disabled', false);
    } else {
      $('.product-form__cart-submit').prop('disabled', true);
    }
  });

  // すべてのスライド枚数
  $(document).ready(function () {
    var size = $('.product-single__media-wrapper').length;
    var initial = $('.product-single__media-wrapper:not(.hide)').index();
    $('.slide__all').text(size);
    $('.slide__current').text(initial);
  });

  // 現在のスライド位置
  $('.product-single__thumbnails-item').on('click', function () {
    var index = $('.product-single__thumbnails-item').index(this) + 1;
    $('.slide__current').text(index);
  });

  // コレクションタブ切り替え（商品ページ用）
  $('.js-tab-panel-prdt .tab-btn-prdt').on('click', function () {
    var num = $(this).data('num');
    var tabWrap = $(this).parents('.tab-wrap');
    var tabBtn = tabWrap.find(".tab-btn-prdt");
    var tabContents = tabWrap.find('.tab-panel-prdt');
    $(".tab-btn-prdt").removeClass('active');
    $(this).addClass('active');
    var elmIndex = tabBtn.index(this);
    $('.tab-panel-prdt').removeClass('active');
    $('.panel' + num).addClass('active');
  });

  // 商品画像を正方形に
  $(window).on('load resize', function () {
    var prdt_width = $('.product-single__media').innerWidth();
    var prop = {
      "width": prdt_width,
      "height": prdt_width
    }
    $('.product-single__media img').css(prop);

    var thum_img = $('.product-single__thumbnails-item');
    var thum_width = thum_img.innerWidth();
    thum_img.css('height', thum_width);
    var t_prop = {
      "width": thum_width,
      "height": thum_width
    }
    $('.product-single__thumbnail-image').css(t_prop);
  });

  // youtubeのiframeをdivで囲む
  $('.product-single__description iframe').each(function(index) {
    var src = $(this).attr('src');
    if(src.indexOf('youtube') > -1) {
      $(this).wrap('<div class="youtube">');
    }
  });

  $('.js-product-attention').hover( function () {
    let position = $(this).offset();

    if ($(window).width() > 750) {
      $('.js-product-attention-text').removeClass('pc-left').fadeIn('fast');

      if (position.left < 170) {
        $('.js-product-attention-text').addClass('pc-left').css('left', '250px');
      }
    }
  }, function() {
    if ($(window).width() > 750) {
      $('.js-product-attention-text').fadeOut('fast');
    }
  })


  $('.js-product-attention').on('click', function () {
    if ($(window).width() < 750) {
      $('.js-product-attention-text').fadeToggle('fast');

      let position = $(this).offset(),
          targetWidth = $(window).width() / 2;

      if ($(window).width() > 450) {
        $('.js-product-attention-text').css('left', position.left);
      } else {

        if (position.left > targetWidth) {
          $('.js-product-attention-text').addClass('right').removeClass('left');
        } else {
          $('.js-product-attention-text').addClass('left').removeClass('right');
        }
      }
    }
  })

  $(window).resize(function() {
    $('.js-product-attention-text').css('left', '');
  });

  /**
   * カートに入れる SPポップアップ
   */
  // お届け日エリア コピー
  $('.template-product .product__attention').clone(true).insertBefore('.product__quantity_cart');

  // モーダル開く
  $('.template-product .fixedcart-btn, .template-product .product-form__sp__static__btn').click(function(){
    $('.template-product .product-form__sp, .template-product .product-form__sp__bg').fadeIn();
  });

  // モーダル閉じる
  $('.template-product .product-form__sp__bg, .template-product .product-form__sp__ttl__btn').click(function(){
    $('.template-product .product-form__sp, .template-product .product-form__sp__bg').fadeOut();
  });
});